import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.container = {};

    this.header = {
      mb: ['24px', null, '32px'],
    };

    this.superheading = {
      fontSize: ['12px', null, '14px'],
      fontWeight: 600,
      letterSpacing: '1.5px',
      textTransform: 'uppercase',
      mb: '8px',
      lineHeight: 'normal',
    };

    this.heading = {
      fontSize: ['32px', null, '48px'],
      fontWeight: 700,
      lineHeight: 1.1,
      letterSpacing: '-0.02em',
    };

    this.scrollWrapper = {
      position: 'relative',
      width: '100vw',
      ml: 'calc(-50vw + 50%)',
    };

    this.scrollContainer = {
      display: 'flex',
      gap: '10px',
      height: ['280px', null, '500px'],
      overflowX: 'auto',
      overflowY: 'hidden',
      pl: ['16px', null, '48px'],
      pr: ['16px', null, '48px'],
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      WebkitOverflowScrolling: 'touch',
      '&::-webkit-scrollbar': { display: 'none' },
      cursor: 'grab',
      '&:active': { cursor: 'grabbing' },
    };

    this.tileBig = {
      position: 'relative',
      flexShrink: 0,
      height: '100%',
      aspectRatio: '1',
      borderRadius: '12px',
      overflow: 'hidden',
    };

    this.smallPair = {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      flexShrink: 0,
      height: '100%',
      width: ['calc((280px - 10px) / 2)', null, 'calc((500px - 10px) / 2)'],
    };

    this.tileSmall = {
      position: 'relative',
      flex: 1,
      width: '100%',
      borderRadius: '12px',
      overflow: 'hidden',
    };

    this.image = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    };

    this.name = {
      position: 'absolute',
      bottom: ['10px', null, '12px'],
      left: ['10px', null, '12px'],
      color: 'white',
      fontSize: ['13px', null, '14px'],
      fontWeight: 500,
      lineHeight: 'normal',
      zIndex: 1,
      textShadow: '0 1px 3px rgba(0,0,0,0.3)',
    };

    this.playPauseBtn = {
      position: 'absolute',
      bottom: '16px',
      right: ['16px', null, '48px'],
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      bg: 'rgba(0,0,0,0.5)',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2,
      transition: 'background-color 0.2s',
      '&:hover': {
        bg: 'rgba(0,0,0,0.7)',
      },
    };

    this.ctaWrapper = {
      display: 'flex',
      justifyContent: 'center',
      mt: ['32px', null, '40px'],
    };

    this.ctaLink = {
      width: ['100%', null, 'auto'],
      textAlign: 'center',
    };
  })()
);
